module.exports = __webpack_public_path__ + "static/media/region.32100712.svg";